const t={desktop:300,tablet:255,mobile:280},e="·";export{t as HEIGHT,e as MATURITY_SYMBOL};
//# sourceMappingURL=constants.js.map
